import type { fabric } from 'fabric';
import React, { useCallback } from 'react';
import CommitNumberField from './shared/commit-number-field';
import InspectorRow from './shared/inspector-row';
import InspectorSection from './shared/inspector-section';
import { useCommonFabricProp } from './shared/use-common-fabric-prop';
import type { ObjectInspectorProps } from './types';

const MIXED = '(разное)';

const PlaceholderTransformSection: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const left = useCommonFabricProp<number>(objects, 'left', editor);
  const top = useCommonFabricProp<number>(objects, 'top', editor);
  const width = useCommonFabricProp<number>(objects, 'width', editor);
  const height = useCommonFabricProp<number>(objects, 'height', editor);
  const angle = useCommonFabricProp<number>(objects, 'angle', editor);

  // See common/transform-section: X/Y are bulk-unsafe inside an ActiveSelection.
  const showPosition = objects.length === 1;

  const refitAll = useCallback(() => {
    for (const o of objects) editor.placeholders?.refit(o as fabric.Group);
  }, [editor, objects]);

  const commitWith = useCallback(
    (setter: (v: number) => void) => (value: number) => {
      setter(value);
      refitAll();
    },
    [refitAll],
  );

  return (
    <InspectorSection title="Трансформация">
      {showPosition && (
        <>
          <InspectorRow label="X">
            <CommitNumberField value={left.value} onCommit={commitWith(left.setValue)} />
          </InspectorRow>
          <InspectorRow label="Y">
            <CommitNumberField value={top.value} onCommit={commitWith(top.setValue)} />
          </InspectorRow>
        </>
      )}
      <InspectorRow label="Ширина">
        <CommitNumberField
          value={width.isMixed ? undefined : width.value}
          onCommit={commitWith(width.setValue)}
          min={1}
          placeholder={width.isMixed ? MIXED : undefined}
        />
      </InspectorRow>
      <InspectorRow label="Высота">
        <CommitNumberField
          value={height.isMixed ? undefined : height.value}
          onCommit={commitWith(height.setValue)}
          min={1}
          placeholder={height.isMixed ? MIXED : undefined}
        />
      </InspectorRow>
      <InspectorRow label="Угол">
        <CommitNumberField
          value={angle.isMixed ? undefined : angle.value}
          onCommit={commitWith(angle.setValue)}
          step={1}
          placeholder={angle.isMixed ? MIXED : undefined}
        />
      </InspectorRow>
    </InspectorSection>
  );
};

export default PlaceholderTransformSection;
